// BlurIcon.js
import React from 'react';

// SVG for the blur icon (from user image)
const BlurIcon = ({ size = 24, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <circle cx="128" cy="128" r="120" stroke={color} strokeWidth="16" fill="none" />
    <circle cx="128" cy="128" r="72" fill={color} opacity="0.35" />
    <circle cx="128" cy="128" r="40" fill={color} opacity="0.7" />
    <circle cx="128" cy="128" r="16" fill={color} />
  </svg>
);

export default BlurIcon;
